export default "__VITE_ASSET__YvAGeg2C__"